import {makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core/styles';
import {createStyles} from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minWidth: '75vw', //  Calc ViewPort Units: 1080/1440*100
            minHeight: '85vh', // Calc ViewPort Units: 740/900*100
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: theme.spacing(8),
        },
    })
);

export const blankClasses = {
    flex: '1 1 auto',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
};
